class Adherent {
  loginAdherent() {
    if (!document.body.classList.contains('user-logged-in')) {
      const buttons = document.querySelectorAll('.btn-login-adherent, nav#block-espacepersonnel ul.menu>li:first-child, #block-votreespacepersonnel a.btn')
      const openIdForm = document.getElementById('openid-connect-login-form');

      if (openIdForm) {
        buttons.forEach(button => {
          button.addEventListener('click', e => {
            e.preventDefault();
            openIdForm.submit();
          });
        })
      }
    }
  }

  sideBarAbonnements() {
    $(window).on('load', function () {
      $('aside.layout-sidebar-right').prepend('<h2>Mes abonnements</h2>');
    });
  }
}

export default Adherent;
